export default {
  name: 'valuationRule',
  data () {
    return {
      labelPosition: 'right',
      page: {
        size: 100,
        num: 1
      },
      tooltip: true,
      formInline: {
        strategyId: '',
        systemId: '',
        ruleNameCn: '',
        ruleState: '',
        effective: ''
      },
      strategyData: [],
      tableList: [],
      page2: {
        size: 10,
        num: 1
      },
      ruleArr: [],
      totalRows: 0,
      editBlooen: true,
      copyBlooen: true,
      switchBlooen: true
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  created () {
    this.querySearch()
    this.queryList()
  },
  activated () {
    this.queryList()
  },
  methods: {
    /* 表格状态值转换 */
    ruleStatus (row) {
      if (row.ruleState == '0') {
        return '停用'
      } else if (row.ruleState == '1') {
        return '启用'
      } else if (row.ruleState == '2') {
        return '测试'
      } else {
        return ''
      }
    },
    effectiveStatus (row) {
      if (row.effective == '0') {
        return '未生效'
      } else if (row.effective == '1') {
        return '已生效'
      } else {
        return ''
      }
    },
    querySearch () {
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      let _self = this
      this.$store.dispatch('getSystem') // 请求业务系统
      /* 查询计价策略列表 */
      this.$axios
        // .post(this.$API.valuation.queryStrategyListByPage, params)
        // .get('http://172.16.9.73:5010/agw/chargeStrategyCtr/queryStrategyList', {})
        .post(this.$API.product.queryStrategyList, {})
        .then(function (r) {
          _self.strategyData = r.data.resData
        })
        .catch(function (error) {})
    },
    /* 计价规则列表 */
    queryList () {
      // let Remainder = this.totalRows % this.page2.size
      // let integer = parseInt(this.totalRows / this.page2.size) + 1
      // console.log(Remainder)
      // let length
      // if (Remainder !== 0) {
      //   length = Remainder - this.ruleArr.length
      // } else {
      //   if (this.ruleArr.length === this.page2.size) {
      //     length = 0
      //   }
      // }
      // if (length === 0) {
      //   if (integer === this.page2.num) { // 判断是否在最后一页
      //     this.page2.num = this.page2.num - 1 // 最后一页减一
      //   }
      // }
      let id = this.formInline.systemId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page2.num,
        pageSize: this.page2.size,
        sysIds: sysIds,
        strategyId: this.formInline.strategyId
          ? this.formInline.strategyId
          : null,
        ruleNameCn: this.formInline.ruleNameCn
          ? this.formInline.ruleNameCn
          : null,
        ruleState: this.formInline.ruleState ? this.formInline.ruleState : null,
        effective: this.formInline.effective ? this.formInline.effective : null
      }
      let _self = this
      this.$axios
        .post(this.$API.valuation.queryChargeRuleListByPage, params)
        .then(function (r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 点击查询按钮 */
    onSearch () {
      this.page2.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    handleEdit (index,value) {
      this.$router.push({
        path: '/editRule',
        query: {
          ruleId: value.ruleId,
          copy: false
        }
      })
    },
    detail (index, value) {
      this.$router.push({
        path: '/detailRule',
        query: {
          ruleId: value.ruleId
        }
      })
    },
    handleCopy (index,value) {
      this.$router.push({
        path: '/copyRule',
        query: {
          ruleId: value.ruleId,
          copy: true
        }
      })
    },
    handleAdd () {
      this.$router.push({
        path: '/addRule'
      })
    },
    moreDelete () {
      if (!this.ruleArr.length) {
        this.$message.warning('请选择计价规则!')
        return
      }
      console.log(this.ruleArr)
      let op = {}
      op.ruleIds = this.ruleArr
      let _this = this
      this.$confirm('此操作将永久删除计价规则, 是否继续?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$axios
          .post(this.$API.valuation.deleteBatchChargeRule, op)
          .then(function (r) {
            _this.$message({
              type: 'success',
              message: '删除成功'
            })
            _this.queryList()
          })
          .catch(function (error) {})
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
      // this.handleDelete(0, { supServiceId: this.supArr[0] })
    },
    changeFun (val) { // checkbox 选中时获取服务id
      this.ruleArr = []
      if (val.length) {
        for (let v of val) {
          this.ruleArr.push(v.ruleId)
        }
      }
      console.log(val)
    },
    handleDel () {},
    handleSelectionChange () {},
    /* 切换状态 启用/禁用 */
    changeStatus (index,value) {
      if (value.ruleState == 1) {
        value.ruleState = 0
        let params = {
          ruleId: value.ruleId,
          ruleState: '1'
        }
        this.$confirm('确认是否修改此策略的状态为启用？', '启用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(this.$API.valuation.updateChargeRuleStatus, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '启用成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      } else {
        value.ruleState = 1
        let params = {
          ruleId: value.ruleId,
          ruleState: '0'
        }
        this.$confirm('确认是否修改此策略的状态为停用？', '停用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(this.$API.valuation.updateChargeRuleStatus, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '停用成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      }
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page2.size = val
      this.page2.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page2.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/valuation/valuationRule.js